import * as actionTypes from '../Register_action.types';

const initialState = {
  returnsForms: [],
  loading: false,
  error: null,
  employees: [],
  returnsList: [],
  returnDetail: null,
  returnsMessage: null,
  message: '',
  returnYearContext: null,
  returnYearLoading: false,
  returnYearError: null,
};

export const GET_RETURNSNEW_FORMS_REQUEST = 'GET_RETURNSNEW_FORMS_REQUEST';
export const GET_RETURNSNEW_FORMS_SUCCESS = 'GET_RETURNSNEW_FORMS_SUCCESS';
export const GET_RETURNSNEW_FORMS_FAILURE = 'GET_RETURNSNEW_FORMS_FAILURE';
const returnsFormsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_RETURNSNEW_FORMS_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_RETURNSNEW_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        returnsForms: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };
    case actionTypes.GET_RETURNSNEW_FORMS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actionTypes.CREATE_GENERATENEW_FORM_REQUEST:
    case actionTypes.GET_RETURNSNEW_FORMS_REQUEST:
    case actionTypes.GET_RETURN_FORM_REQUEST:
    case actionTypes.CREATE_RETURNS_FORM_REQUEST:
    case actionTypes.UPDATE_RETURNS_FORM_REQUEST:
    case actionTypes.DELETE_RETURNS_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        returnsMessage: null,
      };

    case actionTypes.GET_RETURNSNEW_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        returnsList: action.payload,
        error: null,
      };

    case actionTypes.GET_RETURN_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        returnDetail: action.payload,
        error: null,
      };
    case actionTypes.CREATE_GENERATENEW_FORM_SUCCESS:
    case actionTypes.CREATE_RETURNS_FORM_SUCCESS:
    case actionTypes.UPDATE_RETURNS_FORM_SUCCESS:
    case actionTypes.DELETE_RETURNS_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        returnsMessage: action.payload,
        error: null,
      };
    case actionTypes.CREATE_GENERATENEW_FORM_FAILURE:
    case actionTypes.GET_RETURNSNEW_FORMS_FAILURE:
    case actionTypes.GET_RETURN_FORM_FAILURE:
    case actionTypes.CREATE_RETURNS_FORM_FAILURE:
    case actionTypes.UPDATE_RETURNS_FORM_FAILURE:
    case actionTypes.DELETE_RETURNS_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case actionTypes.GET_RETURN_SELECTED_YEAR_REQUEST:
      return {
        ...state,
        returnYearLoading: true,
        returnYearError: null,
      };

    case actionTypes.GET_RETURN_SELECTED_YEAR_SUCCESS:
      return {
        ...state,
        returnYearLoading: false,
        returnYearContext: action.payload,
        returnYearError: null,
      };

    case actionTypes.GET_RETURN_SELECTED_YEAR_FAILURE:
      return {
        ...state,
        returnYearLoading: false,
        returnYearError: action.payload,
        returnYearContext: null,
      };


    default:
      return state;
  }
};




export default returnsFormsReducer;